import con from '../../../../connection';
var path = '/check';
export var check = function (url) { return function () { return ({
    post: function (param) { return con.post(url + path, param); },
}); }; };
